import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 1.6rem;
  white-space: normal;
  text-align: center;
`

export const Icon = styled.div`
  background-color: #f2f3f7;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2.4rem;
`

export const Title = styled.p`
  color: ${({ theme }) => theme.colors.darkGrey};
  font-size: 1.8rem;
  font-weight: 600;
  height: 2.3rem;
  margin-bottom: 1.6rem;
`

export const Description = styled.p`
  color: #545557;
  font-size: 1.6rem;
  line-height: 2rem;
  padding: 0 7rem;

  span {
    font-weight: 600;
  }
`
